import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  insertFechaNoEntrega,
  getFechasNoEntrega,
  updateFechaNoEntrega,
  deleteFechaNoEntrega,
  getFechasNoEntregaProvincia,
  updateFechaNoEntregaProvincia,
  deleteFechasNoEntregaProvincias,
  getFechasNoEntregaCategoriaPerso,
  updateFechaNoEntregaCategoriaPerso,
  deleteFechaNoEntregaCategoriaPerso,
  getFechasNoEntregaCategoriaPersoDia,
  updateFechaNoEntregaCategoriaPersoDia,
  deleteFechasNoEntregaCategoriaPersoDia,
  getFechasNoEntregaDias,
  updateFechaNoEntregaDia,
  getFechasNoEntregaConfiguracionCategoria,
  updateFechaNoEntregaConfiguracionCategoria,
  getFechaNoEntregaById,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FECHAS_NO_ENTREGA() {
  try {
    const fechasNoEntregaData = yield call(getFechasNoEntrega)
    if (fechasNoEntregaData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_LOAD_SUCCEEDED,
        payload: fechasNoEntregaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas no entrega')
      put({
        type: actions.FECHA_NO_ENTREGA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHA_NO_ENTREGA(action) {
  try {
    const fechaNoEntregaData = yield call(getFechaNoEntregaById, action.payload)
    if (fechaNoEntregaData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_BY_ID_LOAD_SUCCEEDED,
        payload: fechaNoEntregaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fecha no entrega')
      put({
        type: actions.FECHA_NO_ENTREGA_BY_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_BY_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_NO_ENTREGA_PROVINCIA(action) {
  try {
    const fechasNoEntregaProvinciaData = yield call(getFechasNoEntregaProvincia, action.payload)
    if (fechasNoEntregaProvinciaData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_SUCCEEDED,
        payload: fechasNoEntregaProvinciaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas no entrega provincia')
      put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FECHA_NO_ENTREGA(action) {
  try {
    const fechaNoEntregaObj = yield call(insertFechaNoEntrega, action.payload)
    if (fechaNoEntregaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha no entrega creada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_INSERT_SUCCEEDED,
        payload: fechaNoEntregaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear fecha no entrega')
      yield put({
        type: actions.FECHA_NO_ENTREGA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear fecha no entrega')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_NO_ENTREGA(action) {
  try {
    const fechaNoEntregaObj = yield call(updateFechaNoEntrega, action.payload)
    if (fechaNoEntregaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha no entrega modificada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_UPDATE_SUCCEEDED,
        payload: fechaNoEntregaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha no entrega')
      yield put({
        type: actions.FECHA_NO_ENTREGA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHA_NO_ENTREGA(action) {
  try {
    const fechaNoEntregaResult = yield call(deleteFechaNoEntrega, action.payload)
    if (fechaNoEntregaResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha No Entrega eliminada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Fecha No Entrega')
      yield put({
        type: actions.FECHA_NO_ENTREGA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Fecha No Entrega')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_NO_ENTREGA_PROVINCIA(action) {
  try {
    const fechaNoEntregaProvinciaObj = yield call(updateFechaNoEntregaProvincia, action.payload)
    if (fechaNoEntregaProvinciaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha no entrega provincia modificada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_SUCCEEDED,
        payload: fechaNoEntregaProvinciaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha no entrega provincia')
      yield put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega provincia')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHAS_NO_ENTREGA_PROVINCIAS(action) {
  try {
    const fechaNoEntregaProvinciaResult = yield call(
      deleteFechasNoEntregaProvincias,
      action.payload,
    )
    if (fechaNoEntregaProvinciaResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha no entrega provincia modificada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha no entrega provincia')
      yield put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega provincia')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO(action) {
  try {
    const fechasNoEntregaCategoriaPersoData = yield call(
      getFechasNoEntregaCategoriaPerso,
      action.payload,
    )
    if (fechasNoEntregaCategoriaPersoData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_SUCCEEDED,
        payload: fechasNoEntregaCategoriaPersoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas no entrega categoria personalizado')
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_NO_ENTREGA_CATEGORIA_PERSO(action) {
  try {
    const fechaNoEntregaCategoriaPersoObj = yield call(
      updateFechaNoEntregaCategoriaPerso,
      action.payload,
    )
    if (fechaNoEntregaCategoriaPersoObj.ok) {
      putMessage(
        messageType.SUCCESS,
        'Fecha no entrega categoria personalizado modificada correctamente',
      )
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_SUCCEEDED,
        payload: fechaNoEntregaCategoriaPersoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha no entrega categoria personalizado')
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega categoria personalizado')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO(action) {
  try {
    const fechaNoEntregaCategoriaPersoResult = yield call(
      deleteFechaNoEntregaCategoriaPerso,
      action.payload,
    )
    if (fechaNoEntregaCategoriaPersoResult.ok) {
      putMessage(
        messageType.SUCCESS,
        'Fecha no entrega categoria personalizado modificada correctamente',
      )
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha no entrega categoria personalizado')
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega categoria personalizado')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA(action) {
  try {
    const fechasNoEntregaCategoriaPersoDiaData = yield call(
      getFechasNoEntregaCategoriaPersoDia,
      action.payload,
    )
    if (fechasNoEntregaCategoriaPersoDiaData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_SUCCEEDED,
        payload: fechasNoEntregaCategoriaPersoDiaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas no entrega categoria personalizado día')
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_NO_ENTREGA_DIAS(action) {
  try {
    const fechasNoEntregaDiasData = yield call(getFechasNoEntregaDias, action.payload)
    if (fechasNoEntregaDiasData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_DIAS_LOAD_SUCCEEDED,
        payload: fechasNoEntregaDiasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas no entrega días')
      put({
        type: actions.FECHA_NO_ENTREGA_DIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_DIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_NO_ENTREGA_DIA(action) {
  try {
    const fechaNoEntregaDiaObj = yield call(updateFechaNoEntregaDia, action.payload)
    if (fechaNoEntregaDiaObj.ok) {
      putMessage(messageType.SUCCESS, 'Día modificada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_DIA_UPDATE_SUCCEEDED,
        payload: fechaNoEntregaDiaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Día')
      yield put({
        type: actions.FECHA_NO_ENTREGA_DIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Día')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_DIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FECHAS_NO_ENTREGA_CONFIGURACION_CATEGORIA(action) {
  try {
    const fechasNoEntregaConfiguracionCategoriaData = yield call(
      getFechasNoEntregaConfiguracionCategoria,
      action.payload,
    )
    if (fechasNoEntregaConfiguracionCategoriaData.ok) {
      yield put({
        type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_SUCCEEDED,
        payload: fechasNoEntregaConfiguracionCategoriaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas no entrega configuración categoría')
      put({
        type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA(action) {
  try {
    const fechaNoEntregaConfiguracionCategoriaObj = yield call(
      updateFechaNoEntregaConfiguracionCategoria,
      action.payload,
    )
    if (fechaNoEntregaConfiguracionCategoriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Configuración categoría modificada correctamente')
      yield put({
        type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_SUCCEEDED,
        payload: fechaNoEntregaConfiguracionCategoriaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar configuración categoría')
      yield put({
        type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar configuración categoría')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA(action) {
  try {
    const fechaNoEntregaCategoriaPersoDiaObj = yield call(
      updateFechaNoEntregaCategoriaPersoDia,
      action.payload,
    )
    if (fechaNoEntregaCategoriaPersoDiaObj.ok) {
      putMessage(
        messageType.SUCCESS,
        'Fecha no entrega categoría personalizado modificada correctamente',
      )
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Fecha no entrega categoría personalizado')
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Fecha no entrega categoría personalizado')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA(action) {
  try {
    const fechaNoEntregaCategoriaPersoDiaResult = yield call(
      deleteFechasNoEntregaCategoriaPersoDia,
      action.payload,
    )
    if (fechaNoEntregaCategoriaPersoDiaResult.ok) {
      putMessage(
        messageType.SUCCESS,
        'Fecha no entrega categoría personalizado modificada correctamente',
      )
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha no entrega categoría personalizado')
      yield put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha no entrega categoría personalizado')
    yield all([
      put({
        type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FECHA_NO_ENTREGA_LOAD_REQUESTED, GET_FECHAS_NO_ENTREGA),
    takeEvery(actions.FECHA_NO_ENTREGA_BY_ID_LOAD_REQUESTED, GET_FECHA_NO_ENTREGA),
    takeEvery(actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_REQUESTED, GET_FECHAS_NO_ENTREGA_PROVINCIA),
    takeEvery(actions.FECHA_NO_ENTREGA_INSERT_REQUESTED, INSERT_FECHA_NO_ENTREGA),
    takeEvery(actions.FECHA_NO_ENTREGA_UPDATE_REQUESTED, UPDATE_FECHA_NO_ENTREGA),
    takeEvery(actions.FECHA_NO_ENTREGA_DELETE_REQUESTED, DELETE_FECHA_NO_ENTREGA),
    takeEvery(
      actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_REQUESTED,
      UPDATE_FECHA_NO_ENTREGA_PROVINCIA,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_REQUESTED,
      DELETE_FECHAS_NO_ENTREGA_PROVINCIAS,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_REQUESTED,
      GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_REQUESTED,
      UPDATE_FECHA_NO_ENTREGA_CATEGORIA_PERSO,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_REQUESTED,
      DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_REQUESTED,
      GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA,
    ),
    takeEvery(actions.FECHA_NO_ENTREGA_DIAS_LOAD_REQUESTED, GET_FECHAS_NO_ENTREGA_DIAS),
    takeEvery(actions.FECHA_NO_ENTREGA_DIA_UPDATE_REQUESTED, UPDATE_FECHA_NO_ENTREGA_DIA),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_REQUESTED,
      GET_FECHAS_NO_ENTREGA_CONFIGURACION_CATEGORIA,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_REQUESTED,
      UPDATE_FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_REQUESTED,
      UPDATE_FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA,
    ),
    takeEvery(
      actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_REQUESTED,
      DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA,
    ),
  ])
}
